module.exports = __webpack_public_path__ + "img/WalletError.8c7410c5b.svg";